<div class="clipboard-icon-wrapper" (click)="toggleState()">
    @if (state === 'copy') {
    <svg id="copy-state-icon" class="copy-icon" [attr.width]="width" [attr.height]="height" viewBox="0 0 12 12"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 2.7069L9.27429 2.7069L9.27429 -1.19145e-07L9.53674e-07 -5.24537e-07L5.46706e-07 9.31035L2.73429 9.31035L2.73429 12L12 12L12 2.7069ZM1.71429 7.58621L1.71429 1.72414L7.56 1.72414L7.56 2.7069L2.73429 2.7069L2.73429 7.58621L1.71429 7.58621ZM4.41429 10.2759L4.41429 4.43103L10.2857 4.43103L10.2857 10.2759L4.41429 10.2759Z"
            [attr.fill]="color" />
    </svg>
    } @else {
    <svg id="check-state-icon" class="copy-icon" [attr.width]="width" [attr.height]="height" viewBox="0 0 12 12"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.02081 12L11.9999 12V4L4.02081 4L4.02081 12ZM7.9791 0V2.66667L2.6597 2.66667L2.6597 8H0V0H7.9791ZM10.265 4.5L11.5 5.355L8.11499 10.23L7.23999 11.5L4.5 8.455L5.61499 7.455L7.08499 9.085L10.265 4.5Z"
            [attr.fill]="color" />
    </svg>
    }
</div>